import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient/PlatformAppsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

const useRefreshPlatformAppMutation = createMutationHook(PlatformAppsApiClient.refreshPlatformApp, {
  mutationKey: ['refreshPlatformApp'],
})

export const useRefreshPlatformApp = () => {
  const { refreshPlatformAppMutation } = useRefreshPlatformAppMutation()

  return {
    refreshPlatformApp: refreshPlatformAppMutation.mutate,
    isLoading: refreshPlatformAppMutation.isLoading,
  }
}
